import {connect} from "react-redux";
import {changeLanguage} from "intl/actions";
import StepInfo from "../index";

const mapStateToProps = (state) => {
  return {
    localesReducer: state.localesReducer
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    changeLanguage: language => dispatch(changeLanguage(language))
  };
};

const StepInfoContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(StepInfo);

export default StepInfoContainer;